<template>
  <div>
    <section class="contact-hero">
      <div class="container">
        <div class="hero-card text-center">
          <h1 class="title">Contacto</h1>
          <p class="subtitle">Cuéntanos tu duda y te respondemos lo antes posible.</p>
          <p class="micro">
            <router-link to="/politica-privacidad">Privacidad</router-link>
          </p>
          <button class="btn-volver mt-3" @click="$router.back()">
            <i class="fas fa-arrow-left"></i> Volver
          </button>
        </div>
      </div>
    </section>

    <div class="container my-5">
      <div class="row g-4">
        <!-- Bloque info -->
        <div class="col-lg-5">
          <div class="info-card">
            <div class="info-item">
              <i class="fas fa-envelope"></i>
              <div>
                <div class="label">Email</div>
                <div class="value">soporte@payoned.com</div>
              </div>
            </div>

            <div class="info-item">
              <i class="fas fa-headset"></i>
              <div>
                <div class="label">Soporte</div>
                <div class="value">Atención por email</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Formulario -->
        <div class="col-lg-7">
          <div class="form-card">
            <div v-if="success" class="alert alert-success">
              ✅ Mensaje enviado. Te responderemos lo antes posible.
            </div>
            <div v-if="error" class="alert alert-danger">
              ❌ {{ error }}
            </div>

            <form @submit.prevent="enviar">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">Nombre*</label>
                  <input v-model.trim="form.nombre" type="text" class="form-control" required maxlength="100" />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">Apellidos*</label>
                  <input v-model.trim="form.apellidos" type="text" class="form-control" required maxlength="100" />
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Email*</label>
                <input v-model.trim="form.email" type="email" class="form-control" required maxlength="255" />
              </div>

              <div class="mb-3">
                <label class="form-label">Mensaje*</label>
                <textarea v-model.trim="form.mensaje" class="form-control" rows="5" required maxlength="2000"></textarea>
              </div>

              <!-- honeypot invisible -->
              <input v-model="form.website" type="text" class="hp" tabindex="-1" autocomplete="off" />

              <div class="form-check mb-3">
                <input v-model="form.acepta" class="form-check-input" type="checkbox" id="acepta" />
                <label class="form-check-label" for="acepta">
                  He leído y acepto la <router-link to="/politica-privacidad">Política de Privacidad</router-link>.
                </label>
              </div>

              <p class="text-muted small mb-4">
                Acceso reservado a mayores de 18 años.
              </p>

              <button class="btn btn-primary w-100" :disabled="loading || !form.acepta">
                <span v-if="loading">Enviando…</span>
                <span v-else>Enviar</span>
              </button>
            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Contacto",
  beforeMount() {
    this.$store.commit('setShowSidenav', false);
    this.$store.commit('setShowNavbar', true);
    this.$store.commit('setShowFooter', true);
  },
  data() {
    return {
      loading: false,
      success: false,
      error: "",
      form: {
        nombre: "",
        apellidos: "",
        email: "",
        mensaje: "",
        acepta: false,
        website: "" // honeypot anti-bots
      },
    };
  },
  methods: {
    async enviar() {
      this.success = false;
      this.error = "";
      this.loading = true;

      try {
         const resp = await axios.post(process.env.VUE_APP_API_BASE_URL + "/api/v2/contacto", this.form, { timeout: 15000 });
        // Si quisieras detectar honeypot: cuando viene solo {res:"OK"} sin mensaje
        if (resp?.data?.res === "OK" && !resp?.data?.mensaje) {
          // probablemente honeypot (o respuesta mínima)
          this.success = true;
          return;
        }
        this.success = true;
        // Si quieres mostrar el mensaje real del backend en el alert verde:
        if (resp?.data?.mensaje) {
          // crea successMsg en data() si quieres
          // this.successMsg = resp.data.mensaje;
        }

        this.form = { nombre:"", apellidos:"", email:"", mensaje:"", acepta:false, website:"" };
      } catch (e) {
        console.error("CONTACTO ERROR:", e?.response || e);
        this.error =
          e?.response?.data?.mensaje ||
          e?.response?.data?.message ||
          (typeof e?.response?.data === "string" ? e.response.data : "") ||
          `No se pudo enviar el mensaje. (${e?.response?.status || "sin status"})`;

      } finally {
        this.loading = false;
      }
    },

  },
};
</script>

<style scoped>
.contact-hero{
  background: linear-gradient(180deg, var(--q-card) 0%, var(--q-bg) 100%);
  color:#fff;
  padding: 34px 0 28px;
}

.hero-card{
  background: rgba(255,255,255,.08);
  border: 1px solid rgba(255,255,255,.12);
  border-radius: 18px;
  padding: 20px 18px;
  max-width: 560px;
  margin: 0 auto; /* ✅ centra la tarjeta */
  /* ✅ fuerza legibilidad */
  color: #fff;
}

.hero-card .title,
.hero-card .subtitle,
.hero-card .micro{
  color: #fff !important;
}


.title{
  font-size: 38px;
  margin: 0 0 6px 0;
  font-weight: 900;
  letter-spacing: .2px;
}

.subtitle{
  opacity:.92;
  margin: 0;
  font-size: 1.05rem;
}

.micro{
  margin: 10px 0 0 0;
  font-size: .85rem;
  opacity: .85;
}
.micro a{ color: var(--q-gold); text-decoration: underline; font-weight:700; }

.info-card, .form-card{
  background: var(--q-card);
  border-radius:16px;
  padding:24px;
  box-shadow:0 10px 30px rgba(0,0,0,.06);
}

.info-item{
  display:flex;
  gap:14px;
  align-items:flex-start;
  padding:14px 0;
  border-bottom:1px solid var(--q-border);
}
.info-item:last-child{ border-bottom:none; }

.label{ font-size:12px; opacity:.7; }
.value{ font-size:16px; font-weight:700; }

.hp{
  position:absolute;
  left:-9999px;
  width:1px;
  height:1px;
  opacity:0;
}

.btn-volver {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid var(--q-border-md);
  color: var(--q-muted);
  border-radius: 8px;
  padding: 6px 14px;
  font-size: .85rem;
  cursor: pointer;
  transition: color .15s, border-color .15s;
}
.btn-volver:hover { color: var(--q-text); border-color: var(--q-gold); }
</style>
